import { ToolbarElement } from './ToolbarElement'

const entryTemplate = `
<div class="toolbar-dropdown-icon"></div>
<div class="toolbar-dropdown-arrow"></div>
`

function createOverlayContent(rowCount: number, colCount: number): HTMLDivElement {
  const res = document.createElement('div')
  res.classList.add('wrapper')
  for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
    const rowDom = document.createElement('div')
    rowDom.classList.add('toolbar-table-row')
    for (let colIndex = 0; colIndex < colCount; colIndex++) {
      const cellDom = document.createElement('div')
      cellDom.classList.add('toolbar-table-cell')
      cellDom.dataset.row = (rowIndex + 1).toString()
      cellDom.dataset.col = (colIndex + 1).toString()
      rowDom.appendChild(cellDom)
    }
    res.append(rowDom)
  }
  return res
}

interface IToolbarTableElementConfig {
  rowCount: number
  colCount: number
  overlayElementWidth: number
  entryElementHeight: number
  topOffset: number
}

export class ToolbarTableElement extends ToolbarElement {
  public entryElement = document.createElement('div')
  public overlayElement = document.createElement('div')
  public cellElements: HTMLElement[] = []
  constructor(
    overlayContainer: HTMLDivElement,
    public readonly name: string,
    public readonly config: IToolbarTableElementConfig,
  ) {
    super(overlayContainer)
    this.initDom()
    this.initEvent()
  }

  public getEntryElement(): HTMLElement {
    return this.entryElement
  }

  protected initDom() {
    this.entryElement.classList.add(`toolbar-dropdown-${this.name}`, 'toolbar-dropdown')
    this.entryElement.innerHTML = entryTemplate

    this.overlayElement.classList.add(`toolbar-dropdown-menu-${this.name}`, 'toolbar-dropdown-menu')
    this.overlayElement.style.width = `${this.config.overlayElementWidth ?? 0}px`

    this.overlayElement.append(createOverlayContent(this.config.rowCount, this.config.colCount))
    this.overlayContainer.appendChild(this.overlayElement)
    this.cellElements.push(
      ...Object.values(this.overlayElement.querySelectorAll<HTMLDivElement>('.toolbar-table-cell')),
    )
  }

  protected initEvent() {
    this.entryElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.overlayElement.addEventListener('mousedown', (event) => {
      event.preventDefault()
    })
    this.entryElement.addEventListener('click', () => {
      this.showOverlay()
    })
    this.overlayElement.addEventListener('click', (event) => {
      this.hideOverlay()
      const target = event.target as HTMLElement
      if (target.classList.contains('toolbar-table-cell')) {
        const rowCount = parseInt(target.dataset.row ?? '0', 10)
        const colCount = parseInt(target.dataset.col ?? '0', 10)
        if (rowCount >= 0 && colCount >= 0) {
          this.emit('choose', rowCount, colCount)
        }
      }
    })
    this.overlayElement.addEventListener('mouseover', (event) => {
      const target = event.target as HTMLElement
      if (target.classList.contains('toolbar-table-cell')) {
        let rowIndex = parseInt(target.dataset.row ?? '0', 10) - 1
        let colIndex = parseInt(target.dataset.col ?? '0', 10) - 1
        if (rowIndex >= 0 && colIndex >= 0) {
          rowIndex = Math.max(rowIndex, 1)
          colIndex = Math.max(colIndex, 1)
          this.cellElements.forEach((cellDom) => {
            const currentRowIndex = parseInt((cellDom as HTMLElement).dataset.row ?? '0', 10) - 1
            const currentColIndex = parseInt((cellDom as HTMLElement).dataset.col ?? '0', 10) - 1
            if (currentRowIndex <= rowIndex && currentColIndex <= colIndex) {
              cellDom.classList.add('selected')
            } else {
              cellDom.classList.remove('selected')
            }
          })
        }
      }
    })
    this.overlayElement.addEventListener('mouseleave', () => {
      this.cellElements.forEach((cellDom) => {
        cellDom.classList.remove('selected')
      })
    })
  }

  protected showOverlay() {
    const overlayElementWidth = this.config.overlayElementWidth ?? 0
    const entryElementHeight = this.config.entryElementHeight ?? 0
    const topOffset = this.config.topOffset ?? 0
    const entryBounding = this.entryElement.getBoundingClientRect()
    const overlayContainerBounding = this.overlayContainer.getBoundingClientRect()

    this.overlayElement.style.left = `${Math.max(
      Math.min(
        entryBounding.left - overlayContainerBounding.left - overlayElementWidth / 2 + entryBounding.width / 2,
        overlayContainerBounding.width - overlayElementWidth - 5,
      ),
      5,
    )}px`
    this.overlayElement.style.top = `${
      entryBounding.top - overlayContainerBounding.top + entryElementHeight + topOffset
    }px`
    this.overlayElement.style.display = 'block'
    document.addEventListener('mousedown', this.onDocumentMousedown, true)
  }

  protected hideOverlay() {
    this.overlayElement.style.display = 'none'
    document.removeEventListener('mousedown', this.onDocumentMousedown, true)
  }

  protected onDocumentMousedown = (event: MouseEvent) => {
    this.overlayElement.contains(event.target as Node) ||
      this.entryElement.contains(event.target as Node) ||
      this.hideOverlay()
  }
}
